import { useEffect } from 'react';

// N-125: сюда ведёт кнопка «Войти в кабинет» из админки (страница клиники или сети) —
// короткоживущий токен и имя цели приходят в query. Кладём в sessionStorage (НЕ
// localStorage) — sessionStorage не шарится между вкладками одного origin, поэтому
// импersonation в новой вкладке не подменяет реальную сессию клиники, если у неё уже
// открыта своя вкладка кабинета в этом же браузере (см. authInterceptor.js — он
// приоритизирует sessionStorage-токен на каждый запрос). Публичный роут.
export default function AdminSession() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const name = params.get('name');
    if (token) {
      sessionStorage.setItem('clinicToken', token);
      sessionStorage.setItem('clinicName', name || '');
      sessionStorage.setItem('impersonated', '1');
    }
    window.location.replace('/dashboard');
  }, []);
  return null;
}
